import { Typography } from 'components';
import styles from './MetricsCategories.module.css';

export default function CategoryEmptyState() {
  return (
    <div className={styles.emptyState}>
      <Typography variant='body-s'>No metrics found.</Typography>
      <Typography variant='body-xs' color='grey'>
        Try adjusting your filters to expand the search.
      </Typography>
    </div>
  );
}
